var React = require('react');

function ArrowsH (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M405.66 288H106.34l-33.77-32 33.77-32h299.32l33.77 32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M358.59 146.37a23.93 23.93 0 0 0 .94 33.92l79.9 75.71-79.9 75.71a23.93 23.93 0 0 0-.94 33.92L369.9 377a24.15 24.15 0 0 0 34.1 0l98.65-98.36a31.92 31.92 0 0 0 0-45.24L404 135a24.15 24.15 0 0 0-34.05 0zM153.41 365.63a23.93 23.93 0 0 0-.94-33.92L72.57 256l79.9-75.71a23.93 23.93 0 0 0 .94-33.92L142.1 135a24.15 24.15 0 0 0-34 0L9.4 233.38a31.92 31.92 0 0 0 0 45.24L108.05 377a24.15 24.15 0 0 0 34.05 0z","className":"fa-primary","key":2})]);
}

ArrowsH.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = ArrowsH;

ArrowsH.default = ArrowsH;
